import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-polling-loading-message',
  templateUrl: './polling-loading-message.component.html'
})
export class PollingLoadingMessageComponent {
  @Input() message = 'Loading...';
  @Input() showRefresh = false;
  @Input() refreshInterval = 15;
  @Output() refresh = new EventEmitter<void>();
} 